import { type ErrorComponentProps, useNavigate } from "@tanstack/react-router";
import { Button } from "@ui/button/button";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import styles from "./error.module.scss";

export function ErrorComponent(error: ErrorComponentProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate({
			to: "/applications",
			search: () => ({
				page: 1,
				search: "",
				startDate: "",
				endDate: "",
				filterStatus: "",
				filters: {},
				tab: "single" as const,
			}),
		});
	};

	const status =
		error.error instanceof AxiosError
			? error.error.response?.status
			: undefined;

	if (status === 403) {
		return (
			<div className={styles.error_container}>
				<div className={styles.error_content}>
					<h1 className={styles.error_title}>{t("no_access.title")}</h1>
					<div className={styles.error_message}>
						<p className={styles.error_message__main}>
							{t("no_access.message")}
						</p>
					</div>

					<Button onClick={handleGoBack}>{t("no_access.retry")}</Button>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.error_container}>
			<div className={styles.error_content}>
				<h1 className={styles.error_title}>{t("error.oops")}</h1>
				<div className={styles.error_message}>
					<p className={styles.error_message__main}>
						{t("error.something_went_wrong")}
					</p>
					<p className={styles.error_message__sub}>
						{t("error.try_again_later")}
					</p>
				</div>

				<p className={styles.error_msg}>
					Error info:{" "}
					{JSON.stringify(
						error.error instanceof Error
							? error.error.message
							: String(error.error),
					)}
				</p>

				<Button onClick={handleGoBack}>{t("error.back_to_home")}</Button>
			</div>
		</div>
	);
}
